import types from './types'
import firebase from 'firebase/app'
import { cloneDeep, pick, last, forEach, clone } from 'lodash'
import 'firebase/firestore'
import { $t } from '../../plugins/VueI18n'
import notifications from '../../services/NotificationService'
import globaltypes from '../globaltypes'
import moment from 'moment'
import config from '../../config'

let firstFetchedDoc = null
let lastFetchedDoc = null

function addFirebaseItemToState (context, doc) {
  let data = doc.data()
  data.key = doc.id
  delete data.title
  delete data.cropIDs
  delete data.titles
  context.commit(types.mutations.add, data)
}

const fields = [
  'key',
  'ID',
  'cropID',
  'done',
  'notes',
  'icon',
  'methodID',
  'period',
  'stepID',
  'title',
  'sendNotifications',
  'userID'
]

export default {
  [types.actions.add]: async (context, planningitem) => {
    const userID = context.getters[globaltypes.user.getters.currentUser].id
    if (planningitem.period) {
      planningitem.userID = userID
      planningitem.period = moment(planningitem.period).toDate()
      if (!planningitem.key) {
        planningitem.done = false
        await firebase.firestore().collection('planning').add(planningitem)
      } else {
        const updatedItem = pick(planningitem, fields)
        context.commit(types.mutations.edit, cloneDeep(updatedItem))
        const id = cloneDeep(updatedItem.key)
        delete updatedItem.key
        firebase.firestore().collection('planning').doc(id).set(updatedItem)
      }
    }
  },
  [types.actions.reload]: context => {
    forEach(['all', 'week', 'month', 'past'], selection => {
      context.commit(types.mutations.setLastItemKey, { selection, key: null })
    })
    context.commit(types.mutations.deleteAll)
    firstFetchedDoc = null
    lastFetchedDoc = null

    context.dispatch(types.actions.load)
  },
  [types.actions.loadLastItem]: async (context, selection) => {
    let sortOrder = 'desc'
    let comparisonOperator = '<'
    let comparisonDate = moment().startOf('day').toDate()
    if (selection === 'past') {
      sortOrder = 'asc'
    } else if (selection === 'all') {
      comparisonOperator = '>='
    } else if (selection === 'week') {
      comparisonDate = moment().add(7, 'days').toDate()
    }

    const userID = context.getters[globaltypes.user.getters.currentUser].id
    let query = firebase.firestore().collection('planning')
    query = query
      .where('userID', '==', userID)
      .where('period', comparisonOperator, comparisonDate)
    if (selection !== 'past') query = query.where('done', '==', false)
    query = query.orderBy('period', sortOrder).limit(1)
    const snapshot = await query.get()

    const key = snapshot.docs.length === 0 ? 'empty' : last(snapshot.docs).id
    context.commit(types.mutations.setLastItemKey, { key, selection })
  },
  [types.actions.load]: async (context, to) => {
    context.commit(globaltypes.ui.mutations.setIsLoadingMoreDataFuture, true)
    const shouldScheduleNotifications = !context.state.lastItemKeys.all

    if (!context.state.lastItemKeys.all) await context.dispatch(types.actions.loadLastItem, 'all')
    if (!context.state.lastItemKeys.week) await context.dispatch(types.actions.loadLastItem, 'week')

    const userID = context.getters[globaltypes.user.getters.currentUser].id
    let query = firebase.firestore().collection('planning')
      .where('userID', '==', userID)
      .where('period', '>=', moment().startOf('day').toDate())
    if (to) query = query.where('period', '<=', to)
    query = query.orderBy('period')
    if (lastFetchedDoc) query = query.startAfter(lastFetchedDoc)
    if (!to) query = query.limit(shouldScheduleNotifications ? config.calendarFetchForNotificationsSize : config.calendarFetchChunkSize)

    const snapshot = await query.get()
    if (!snapshot.empty) {
      lastFetchedDoc = last(snapshot.docs)
      snapshot.forEach(doc => addFirebaseItemToState(context, doc))
    }
    context.commit(globaltypes.ui.mutations.setIsLoadingMoreDataFuture, false)
    context.commit(globaltypes.ui.mutations.setDataLoaded, { tab: 'calendar', val: true })
    if (shouldScheduleNotifications) context.dispatch(types.actions.scheduleNotifications)
  },
  [types.actions.loadPast]: async (context, to) => {
    context.commit(globaltypes.ui.mutations.setIsLoadingMoreDataPast, true)

    if (!context.state.lastItemKeys.past) await context.dispatch(types.actions.loadLastItem, 'past')

    const userID = context.getters[globaltypes.user.getters.currentUser].id
    let query = firebase.firestore().collection('planning')
      .where('userID', '==', userID)
      .where('period', '<', new Date())
    if (to) query = query.where('period', '>=', to)
    query = query.orderBy('period', 'desc')
    if (firstFetchedDoc) query = query.startAfter(firstFetchedDoc)
    if (!to) query = query.limit(config.calendarFetchChunkSize)

    const snapshot = await query.get()
    if (!snapshot.empty) {
      firstFetchedDoc = last(snapshot.docs)
      snapshot.forEach(doc => addFirebaseItemToState(context, doc))
    }
    context.commit(globaltypes.ui.mutations.setIsLoadingMoreDataPast, false)
  },
  [types.actions.deleteAll]: async context => {
    context.dispatch(globaltypes.main.actions.setInformation, $t('calendar.clear_planning'))
    const userID = context.getters[globaltypes.user.getters.currentUser].id

    firebase.firestore().collection('planning')
      .where('userID', '==', userID)
      .get()
      .then(snapshot => {
        var batch = firebase.firestore().batch()

        snapshot.forEach(doc => {
          batch.delete(doc.ref)
        })

        return batch.commit()
      }).then(x => {
        context.dispatch(globaltypes.main.actions.setInformation, $t('calendar.calendar_is_empty'))
      })

    context.commit(types.mutations.deleteAll)
    context.dispatch(types.actions.scheduleNotifications)
  },
  [types.actions.deleteItem]: async (context, planningitem) => {
    await firebase.firestore().collection('planning').doc(planningitem.key).delete()
    context.dispatch(globaltypes.main.actions.setInformation, $t('calendar.removed_action'))
    context.commit(types.mutations.delete, planningitem)

    await context.dispatch(types.actions.loadLastItem, 'all')
    await context.dispatch(types.actions.loadLastItem, 'week')
    await context.dispatch(types.actions.loadLastItem, 'past')

    context.dispatch(types.actions.scheduleNotifications)
  },
  [types.actions.deleteCultivation]: async (context, planningitem) => {
    context.dispatch(globaltypes.main.actions.setInformation, $t('calendar.remove_cultivation'))
    const cropIDs = context.rootGetters[globaltypes.i18n.getters.allTranslationsPostIDs](planningitem.cropID)
    const userID = context.getters[globaltypes.user.getters.currentUser].id

    let query = firebase.firestore().collection('planning')
      .where('userID', '==', userID)
      .where('methodID', '==', planningitem.methodID)
      .where('cropID', 'in', cropIDs)
    if (planningitem.ID) query = query.where('ID', '==', planningitem.ID)

    const snapshot = await query.get()
    var batch = firebase.firestore().batch()
    snapshot.forEach(doc => batch.delete(doc.ref))
    await batch.commit()

    context.dispatch(globaltypes.main.actions.setInformation, $t('calendar.removed_cultivation'))
    context.commit(types.mutations.deleteCultivation, { planningitem, cropIDs })

    await context.dispatch(types.actions.loadLastItem, 'all')
    await context.dispatch(types.actions.loadLastItem, 'week')
    await context.dispatch(types.actions.loadLastItem, 'past')

    context.dispatch(types.actions.scheduleNotifications)
  },
  [types.actions.clearSession]: (context) => {
    context.commit(globaltypes.planning.mutations.deleteAll)
    forEach(['all', 'week', 'month', 'past'], selection => {
      context.commit(types.mutations.setLastItemKey, { selection, key: null })
    })
    firstFetchedDoc = null
    lastFetchedDoc = null
  },
  [types.actions.scheduleNotifications]: (context) => {
    const actions = context.getters[types.getters.coming].map(action => {
      const crop = context.getters[globaltypes.crops.getters.translatedCropById](action.cropID)
      return { ...action, crop }
    })
    notifications.requestPermission().then(hasPermission => {
      if (hasPermission) notifications.schedule(actions)
      else console.log('no permission')
    })
  }
}
